<template>
    <div class="block">
        <a href="#" :class="isLoad ? 'title open':'title'" @click.prevent="getItems">Количество обучающихся предпрофессиональных классов</a>
        <transition name="fade">
            <div class="content" v-if="isLoad">
                <!--            <p>Ведутся технические работы</p>-->
                <loading v-if="!this.items"/>
                <table v-else>
                    <thead>
                    <tr>
                        <th>Параллель</th>
                        <th>Количество учеников</th>
                        <th>ФИО классного руководителя</th>
                    </tr>
                    </thead>
                    <parallel
                        v-bind:key="key"
                        :parallel="item.program"
                        v-for="(item,key) in items"
                    />
                  <tfoot>
                    <tr>
                      <td>Всего</td>
                      <td>{{ total_pupils }}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
            </div>
        </transition>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Axios from 'axios'
  import _ from 'lodash'
  import Parallel from "./Parallel";
  import Loading from "../Loading";
  export default {
    name: "CountPupils",
    components: {
      'parallel': Parallel,
      'loading': Loading
    },
    computed: {
      ...mapState({
        localNumberStudents: 'numberStudents',
        status: 'status',
        type: 'type'
      }),
      total_pupils: function(){
        let total = 0
        if(this.isLoad) {
          for (let i = 0; i < this.items.length; i++) {
            total += parseInt(this.items[i].program.total)
          }
        }
        return total
      },
    },
    data() {
      return {
        items: false,
        isLoad: false,
      }
    },
    methods: {
      getItems() {
        if (!this.isLoad && !this.items) {
          this.isLoad = true
          const $this = this
          let path = this.$store.state.apiGo +this.$store.state.apiGoCountPupils + this.$store.state.eoId + "?program=" + this.type
          Axios({
            method: "get",
            url: path,
            headers: {
              "Access-Control-Allow-Origin":"*",
              Authorization: 'Bearer ' + this.$store.state.goApiToken
            }
          }).then((res) => {
            $this.items = res.data.data
          }).catch(() => {
            $this.items = []
          })

        } else {
          this.isLoad = !this.isLoad
        }
      },
      filterData(data) {
        if (
          this.$store.state.type == 'eng'
          || this.$store.state.type == 'acad'
        ) {
          return _.filter(data, (o) => {
            return o.classes == "10" || o.classes == "11"
          })
        } else {
          return data
        }
      },
      getCountPupilsByProject(data) {
        let $this = this
        let res = _.filter(data.profile, function (o) {
          return o.projectType == $this.$store.state.type
        });
        return typeof (res[0]) !== 'undefined' ? res[0].total : 0
      },
      filterByProjectType(data) {
        const $this = this
        return _.filter(data, (o) => {
          return o.projectType.altName == $this.type
        })
      }
    },
  }
</script>

<style scoped>

</style>
